import { InputHTMLAttributes } from "react";
import clsx from "clsx";

export type SecondaryInputProps = InputHTMLAttributes<HTMLInputElement>;

export default function SecondaryInput({
  name,
  type,
  className,
  value,
  onChange,
  placeholder,
  ...props
}: SecondaryInputProps) {
  return (
    <input
      name={name}
      type={type}
      className={clsx(
        className,
        "peer",
        "border border-gray-400",
        "peer-focus:border-white focus-visible:border-white peer-hover:border-white",
        "rounded-md bg-transparent py-4 px-3 text-base",
        "text-white",
      )}
      aria-required="true"
      aria-invalid="false"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...props}
    />
  );
}
